import gql from 'graphql-tag'

export const LOGIN = gql`
  mutation login (
    $client_id: String!
    $client_secret: String!
    $grant_type: GrantType!
    $username: String!
    $password: String!
  ) {
    login(input: {
      client_id: $client_id
      client_secret: $client_secret
      grant_type: $grant_type
      username: $username
      password: $password
    }) {
      createdAccessToken {
        access_token
        refresh_token
      }
      success
      message
    }
  }
`

export const REQ_RESET_PASSWORD_TOKEN = gql`
  mutation forgetPassword (
    $email: String!
  ) {
    forgetPassword(input: {
      email: $email
    }) {
      createdForgetPassword {
        resetPasswordToken
      }
      success
      message
    }
  }
`

export const CREATE_RECOMMEND_FUEL = gql`
  mutation CreateRecommendFuel(
    $senderLocationId: Int!
    $receiverLocationId: Int!
    $truckBrandId: Int!
    $amount: Float!
  ) {
    CreateRecommendFuel(input: {
      senderLocationId: $senderLocationId
      receiverLocationId: $receiverLocationId
      truckBrandId: $truckBrandId
      amount: $amount
    }) {
      success
      message
    }
  }
`

export const UPDATE_RECOMMEND_FUEL = gql`
  mutation UpdateRecommendFuel($updateRecommendFuelId: Int!, $amount: Float!) {
    UpdateRecommendFuel(id: $updateRecommendFuelId, amount: $amount) {
      success
      message
    }
  }
`

export const DELETE_RECOMMEND_FUEL = gql`
  mutation DeleteRecommendFuel($deleteRecommendFuelId: Int!) {
    DeleteRecommendFuel(id: $deleteRecommendFuelId) {
      success
      message
    }
  }
`

export const EJECT_TRAILER = gql`
  mutation EjectTrailer(
    $truckId: Int!
  ) {
    EjectTrailer(input: {
      truckId: $truckId
    }){
      updatedTruck{
        id
      }
      success
      message
    }
  }
`

export const RESET_PASSWORD = gql`
  mutation resetPassword (
    $token: String!
    $newPassword: String!
  ) {
    resetPassword(input: {
      token: $token
      newPassword: $newPassword
    }) {
      success
      message
    }
  }
`

export const CREATE_CLIENT = gql`
  mutation createCustomer (
    $companyId: String
    $companyName: String!
    $credit: String
    $branch: String
    $companyAddress: String
    $taxId: String
    $officeNumber: String
    $contactName: String
    $contactNumber: String
    $email: String
    $fax: String
    $websiteUrl: String
    $rateType: CustomerRateType
    $note: String
    $type: CustomerType
    $images: [Upload]
    $typeOfChargeId: Int
    $groupId: Int
    $cargoType: [Int]!
  ) {
    createCustomer(input: {
      companyId: $companyId
      companyName: $companyName
      credit: $credit
      branch: $branch
      companyAddress: $companyAddress
      taxId: $taxId
      officeNumber: $officeNumber
      contactName: $contactName
      contactNumber: $contactNumber
      email: $email
      fax: $fax
      rateType: $rateType
      websiteUrl: $websiteUrl
      note: $note
      type: $type
      images: $images
      typeOfChargeId: $typeOfChargeId
      groupId: $groupId
      cargoType: $cargoType
    }) {
      success
      message
    }
  }
`

export const UPDATE_CLIENT = gql`
  mutation updateCustomer (
    $companyId: String
    $companyName: String
    $branch: String
    $credit: String
    $companyAddress: String
    $taxId: String
    $officeNumber: String
    $contactName: String
    $contactNumber: String
    $email: String
    $fax: String
    $websiteUrl: String
    $note: String
    $type: CustomerType
    $rateType: CustomerRateType
    $id: Int!
    $images: [Upload]
    $typeOfChargeId: Int
    $groupId: Int
    $cargoType: [Int]!
    ) {
    updateCustomer(input: {
      companyId: $companyId
      companyName: $companyName
      credit: $credit
      companyAddress: $companyAddress
      branch: $branch
      taxId: $taxId
      officeNumber: $officeNumber
      contactName: $contactName
      contactNumber: $contactNumber
      email: $email
      fax: $fax
      rateType: $rateType
      websiteUrl: $websiteUrl
      note: $note
      type: $type
      id: $id
      images: $images
      typeOfChargeId: $typeOfChargeId
      groupId: $groupId
      cargoType: $cargoType
    }) {
      success
      message
    }
  }
`

export const SENDERLOCATION_CREATE_IN_THAIGPS = gql`
  mutation SenderLocationCreatePOI ($id: Int!) {
    SenderLocationCreatePOI(id: $id) {
      success
      message
    }
  }
`

export const RECEIVERLOCATION_CREATE_IN_THAIGPS = gql`
  mutation ReceiverLocationCreatePOI ($id: Int!) {
    ReceiverLocationCreatePOI(id: $id) {
      success
      message
    }
  }
`

export const DELETE_TRUCK = gql`
  mutation DeleteTruck ($id: Int!) {
    DeleteTruck(input: {id: $id}) {
      success
      message
    }
  }
`

export const CREATE_TRUCK = gql`
  mutation CreateTruck (
    $plateNumber: String
    $trailerNumber1: String
    $brandId: Int
    # $fleet: Fleet
    $fuelType: FuelType
    $truckWeight: Int
    $remark: String
    $driverId: Int!
    $truckOwnerId: Int!
    $truckTypeId: Int!
    $trailerId: Int
    $chassisNumber: String
  ) {
    CreateTruck(input: {
      plateNumber: $plateNumber
      trailerNumber1: $trailerNumber1
      brandId: $brandId
      # fleet: $fleet
      fuelType: $fuelType
      truckWeight: $truckWeight
      remark: $remark
      driverId: $driverId
      truckOwnerId: $truckOwnerId
      truckTypeId: $truckTypeId
      trailerId: $trailerId
      chassisNumber: $chassisNumber
    }) {
      success
      message
    }
  }
`

export const CREATE_DRIVER = gql`
  mutation CreateDriver (
    $employeeId: Int
    $fullname: String
    $fleetCode: String
    $department: String
    $startDate: Date
    $nationalId: String
    $licenseId: String
    $licenseExpire: Date
    $email: String
    $phonenumber: String
    $platenumber: String
    $quitDate: Date
    $bankAccountNumber: String
    $bankName: String
    $insuranceNumber: String
    $birthDate: Date
    $salary: Float
    $status: DriverStatus
    $companyType: DriverCompanyType
    ) {
    CreateDriver(input: {
      employeeId: $employeeId
      fullname: $fullname
      fleetCode: $fleetCode
      department: $department
      startDate: $startDate
      nationalId: $nationalId
      licenseId: $licenseId
      licenseExpire: $licenseExpire
      email: $email
      phonenumber: $phonenumber
      platenumber: $platenumber
      quitDate: $quitDate
      bankAccountNumber: $bankAccountNumber
      bankName: $bankName
      insuranceNumber: $insuranceNumber
      birthDate: $birthDate
      salary: $salary
      status: $status
      companyType: $companyType
    }) {
      success
      message
    }
  }
`

export const UPDATE_TRUCK = gql`
  mutation UpdateTruck (
    $id: Int!
    $plateNumber: String
    $trailerNumber1: String
    $brandId: Int
    # $fleet: Fleet
    $fuelType: FuelType
    $truckWeight: Int
    $remark: String
    $driverId: Int
    $truckOwnerId: Int
    $truckTypeId: Int
    $status: InputTruckStatus
    $trailerId: Int
    $chassisNumber: String
    $truckFiles: [Upload]
  ) {
    UpdateTruck(input: {
      id: $id
      plateNumber: $plateNumber
      trailerNumber1: $trailerNumber1
      brandId: $brandId
      # fleet: $fleet
      fuelType: $fuelType
      truckWeight: $truckWeight
      remark: $remark
      driverId: $driverId
      truckOwnerId: $truckOwnerId
      truckTypeId: $truckTypeId
      status: $status
      trailerId: $trailerId
      chassisNumber: $chassisNumber
      truckFiles: $truckFiles
    }) {
      success
      message
    }
  }
`

export const UPDATE_TRUCK_BRANDS = gql`
  mutation UpdateTruckBrands (
    $brands: [TruckBrandInput]!
  ) {
    UpdateTruckBrands(input:{
      brands: $brands
    }) {
      success
      message
    }
  }
`

export const UPDATE_DRIVER = gql`
  mutation UpdateDriver (
    $id: Int!
    $employeeId: Int
    $fullname: String
    $fleetCode: String
    $department: String
    $startDate: Date
    $nationalId: String
    $licenseId: String
    $licenseExpire: Date
    $email: String
    $phonenumber: String
    $platenumber: String
    $quitDate: Date
    $bankAccountNumber: String
    $bankName: String
    $insuranceNumber: String
    $birthDate: Date
    $status: DriverStatus
    $salary: Float
    ) {
    UpdateDriver(input: {
      id: $id
      employeeId: $employeeId
      fullname: $fullname
      fleetCode: $fleetCode
      department: $department
      startDate: $startDate
      nationalId: $nationalId
      licenseId: $licenseId
      licenseExpire: $licenseExpire
      email: $email
      phonenumber: $phonenumber
      platenumber: $platenumber
      quitDate: $quitDate
      bankAccountNumber: $bankAccountNumber
      bankName: $bankName
      insuranceNumber: $insuranceNumber
      birthDate: $birthDate
      status: $status
      salary: $salary
    }) {
      success
      message
    }
  }
`

export const UPDATE_ROLE = gql`
  mutation UpdateRole (
    $id: Int!
    $isActive: Boolean
    $permissionId: Int
    ) {
      UpdateRole(input: {
        id: $id
        isActive: $isActive
        permissionId: $permissionId
    }) {
      success
      message
    }
  }
`

export const CREATE_JOB = gql`
  mutation CreateJob (
    $jobCode: String
    $number: String
    $customerId: Int!
    $contractStart: Date
    $contractEnd: Date
    $cargo: String
    $contractWeight: Int
    $dealType: DEALTYPE
    $unit: UNIT
    $feeRate: Float!
    $remark: String
    $Jobfiles: [Upload]
    $startDestination: Int
    $endDestination: Int
    $predealPrice: Float
    $truckOwnerFeeRate: Float!
    $companyType: JobCompanyType
    $distance: Float!
    $availableOrder: Int
    $average: Float
  ) {
    CreateJob (input: {
      jobCode: $jobCode
      number: $number
      customerId: $customerId
      contractStart: $contractStart
      contractEnd: $contractEnd
      cargo: $cargo
      contractWeight: $contractWeight
      dealType: $dealType
      unit: $unit
      feeRate: $feeRate
      remark: $remark
      Jobfiles: $Jobfiles
      startDestination: $startDestination
      endDestination: $endDestination
      predealPrice: $predealPrice
      truckOwnerFeeRate: $truckOwnerFeeRate
      companyType: $companyType
      distance: $distance
      availableOrder: $availableOrder
      average: $average
    }) {
      success
      message
    }
  }
`

export const UPDATE_JOB = gql`
  mutation UpdateJob (
    $id: Int!
    $number: String
    $customerId: Int
    $contractStart: Date
    $contractEnd: Date
    $cargo: String
    $contractWeight: Int
    $unit: UNIT
    $feeRate: Float
    $remark: String
    $Jobfiles: [Upload]
    $startDestination: Int
    $endDestination: Int
    $predealPrice: Float
    $truckOwnerFeeRate: Float
    $distance: Float
    $average: Float
    $availableOrder: Int
  ) {
    UpdateJob (input: {
      number: $number
      customerId: $customerId
      contractStart: $contractStart
      contractEnd: $contractEnd
      cargo: $cargo
      contractWeight: $contractWeight
      unit: $unit
      remark: $remark
      Jobfiles: $Jobfiles
      id: $id
      startDestination: $startDestination
      endDestination: $endDestination
      feeRate: $feeRate
      predealPrice: $predealPrice
      truckOwnerFeeRate: $truckOwnerFeeRate
      distance: $distance
      average: $average
      availableOrder: $availableOrder
    }) {
      success
      message
    }
  }
`

export const UPDATE_USER = gql`
  mutation UpdateUser (
    $id: Int!
    $roleId: Int
    $warehouseId: [Int]
    $driverId: Int
    $customerId: [Int]
    $senderLocationId: Int
    $receiverLocationId: Int
    $gasstationId: Int
  ) {
    UpdateUser(input: {
      id: $id
      roleId: $roleId
      warehouseId: $warehouseId
      driverId: $driverId
      customerId: $customerId
      senderLocationId: $senderLocationId
      receiverLocationId: $receiverLocationId
      gasstationId: $gasstationId
    }) {
      success
      message
    }
  }
`
export const CREATE_TRUCK_OWNER = gql`
  mutation CreateTruckowner(
    $code: String
    $status: TruckOwnerStatus
    $nameTh: String
    $nameEn : String
    $type: TruckOwnerType
    $rate: Float
    $description: String
    $taxId: String
  ){
    CreateTruckowner(input:{
      code: $code
      status: $status
      nameTh: $nameTh
      nameEn : $nameEn
      rate: $rate
      description: $description
      type: $type
      taxId: $taxId
    }){
      success
      message
    }
  }
`

export const UPDATE_TRUCK_OWNER = gql`
  mutation UpdateTruckowner(
    $id: Int!
    $code: String
    $status: TruckOwnerStatus
    $nameTh: String
    $nameEn : String
    $rate: Float
    $type: TruckOwnerType
    $description: String
    $taxId: String
  ){
    UpdateTruckowner(input:{
      id: $id
      code: $code
      status: $status
      nameTh: $nameTh
      nameEn : $nameEn
      rate: $rate
      type: $type
      description: $description
      taxId: $taxId
    }){
      success
      message
    }
  }
`

export const CREATE_GAS_STATION = gql`
  mutation CreateGasstation (
    $name: String
    $code: String
    $company: GasstationCompany
    $contactnumber: String
    $remark: String
    $taxId: String
    $creditTerm: Int
    $email: String
    $officialName: String
    $images: [Upload]
  ){
    CreateGasstation (input:{
      name: $name
      code: $code
      company: $company
      contactnumber: $contactnumber
      remark: $remark
      images: $images
      taxId: $taxId
      creditTerm: $creditTerm
      email: $email
      officialName: $officialName
    }) {
      success
      message
    }
  }
`

export const CREATE_BILL = gql`
  mutation CreateBill (
    $dueDate: Date!
    $remark: String
    $jobId: Int!
    $images: [Upload]
    $invoicesId: [Int]!
  ){
    CreateBill (input:{
      dueDate: $dueDate
      remark: $remark
      jobId: $jobId
      images: $images
      invoicesId: $invoicesId
    }) {
      success
      message
    }
  }
`

export const DELETE_BILL = gql`
  mutation DeleteBill (
    $id: Int!
  ){
    DeleteBill (input:{
      id: $id
    }) {
      success
      message
    }
  }
`

export const UPDATE_GAS_STATION = gql`
  mutation UpdateGasstation (
    $id: Int!
    $name: String
    $code: String
    $company: GasstationCompany
    $contactnumber: String
    $remark: String
    $images: [Upload]
    $taxId: String
    $creditTerm: Int
    $email: String
    $officialName: String
  ){
    UpdateGasstation (input:{
      id: $id
      name: $name
      code: $code
      company: $company
      contactnumber: $contactnumber
      remark: $remark
      images: $images
      taxId: $taxId
      creditTerm: $creditTerm
      email: $email
      officialName: $officialName
    }) {
      success
      message
    }
  }
`

export const DELETE_GAS_STATION = gql`
  mutation DeleteGasstation (
    $id: Int!
  ){
    DeleteGasstation (input:{
      id: $id
    }) {
      success
      message
    }
  }
`

export const ACTIVATE_GAS_STATION = gql`
  mutation ActivateGasstation (
    $id: Int!
    $isActive: Boolean!
  ){
    ActivateGasstation (input:{
      id: $id
      isActive: $isActive
    }) {
      success
      message
    }
  }
`

export const CREATE_FUEL_ORDER = gql`
  mutation CreateFuelOrder($input: CreateFuelOrderInput) {
    CreateFuelOrder(input: $input) {
      createdFuelOrder {
        id
      }
      success
      message
    }
  }
`

export const CANCEL_FUEL_ORDER = gql`
  mutation UpdateFuelOrder (
    $id: Int!
    $status: FuelOrderStatus
  ) {
    UpdateFuelOrder (input:{
      id: $id
      status: $status
    }) {
      success
      message
    }
  }
`

export const LOST_FUEL_ORDER = gql`
  mutation CreateFuelCompensation (
    $fuelId: Int!
    $totalDeduct: Int
    $nextOrder: Boolean
  ) {
    CreateFuelCompensation (input:{
      fuelId: $fuelId
      totalDeduct: $totalDeduct
      nextOrder: $nextOrder
    }) {
      success
      message
    }
  }
`

export const CREATE_SHIPPING_OREDER = gql`
  mutation CreateShippingorder (
    $shippingVolume: String!
    $shippingNumber: String!
    $customerId: Int!
    $jobId: Int!
    $startDestination: Int!
    $endDestination: Int!
    $assignDate: Date!
    $remark: String
    $images: [Upload]
    $compensation: Float
    $weightDifferenceLimit: Float
    $expensesHighway: Float
    $expensesEntranceStart: Float
    $expensesEntranceEnd: Float
    $expensesPickupStart: Float
    $expensesPickupEnd: Float
    $expensesOther: Float
    $feePickupHeavy: Float
    $feePierEntrance: Float
    $feePickupNormal: Float
    $feeOther: Float
    $unit: ShippingUnitType
    $containerOption: ContainerOption
  ){
    CreateShippingorder (input: {
      shippingVolume: $shippingVolume
      shippingNumber: $shippingNumber
      customerId: $customerId
      jobId: $jobId
      startDestination: $startDestination
      endDestination: $endDestination
      assignDate: $assignDate
      remark: $remark
      images: $images
      unit: $unit
      compensation: $compensation
      weightDifferenceLimit: $weightDifferenceLimit
      expensesHighway: $expensesHighway
      expensesEntranceStart: $expensesEntranceStart
      expensesEntranceEnd: $expensesEntranceEnd
      expensesPickupStart: $expensesPickupStart
      expensesPickupEnd: $expensesPickupEnd
      expensesOther: $expensesOther
      feePickupHeavy: $feePickupHeavy
      feePierEntrance: $feePierEntrance
      feePickupNormal: $feePickupNormal
      feeOther: $feeOther
      containerOption: $containerOption
    }) {
      createdShippingorder {
        id
      }
      success
      message
    }
  }
`

export const UPDATE_SHIPPING_OREDER = gql`
  mutation UpdateShippingorder (
    $id: Int!
    $shippingVolume: String
    $shippingNumber: String
    $customerId: Int
    $jobId: Int
    $startDestination: Int
    $endDestination: Int
    $assignDate: Date
    $remark: String
    $images: [Upload]
    $compensation: Float
    $weightDifferenceLimit: Float
    $expensesHighway: Float
    $expensesEntranceStart: Float
    $expensesEntranceEnd: Float
    $expensesPickupStart: Float
    $expensesPickupEnd: Float
    $expensesOther: Float
    $feePickupHeavy: Float
    $feePierEntrance: Float
    $feePickupNormal: Float
    $feeOther: Float
    $containerOption: ContainerOption
  ){
    UpdateShippingorder (input: {
      id: $id
      shippingVolume: $shippingVolume
      shippingNumber: $shippingNumber
      customerId: $customerId
      jobId: $jobId
      startDestination: $startDestination
      endDestination: $endDestination
      assignDate: $assignDate
      remark: $remark
      images: $images
      compensation: $compensation
      weightDifferenceLimit: $weightDifferenceLimit
      expensesHighway: $expensesHighway
      expensesEntranceStart: $expensesEntranceStart
      expensesEntranceEnd: $expensesEntranceEnd
      expensesPickupStart: $expensesPickupStart
      expensesPickupEnd: $expensesPickupEnd
      expensesOther: $expensesOther
      feePickupHeavy: $feePickupHeavy
      feePierEntrance: $feePierEntrance
      feePickupNormal: $feePickupNormal
      feeOther: $feeOther
      containerOption: $containerOption
    }) {
      success
      message
    }
  }
`

export const DUPLICATE_SHIPPING_ORDER = gql`
  mutation CopyShippingOrder (
    $id: Int!
    $total: Int!
    $isSameDriver: Boolean
    $isIncludeFuelOrder: Boolean
    $assignDate: Date
    $expiredDate: Date
  ) {
    CopyShippingOrder (input: {
      id: $id
      total: $total
      isSameDriver: $isSameDriver
      isIncludeFuelOrder: $isIncludeFuelOrder
      assignDate: $assignDate
      expiredDate: $expiredDate
    }) {
      success
      message
    }
  }
`

export const CANCEL_SHIPPING_ORDER = gql`
  mutation DeleteShippingorder (
    $id: Int!
    $remainingAmount: Float
  ) {
    DeleteShippingorder(input: {
      id: $id
      remainingAmount: $remainingAmount
    }) {
      success
      message
    }
  }
`

export const MOVE_SHIPPING_ORDER = gql`
  mutation MoveShippingOrder (
    $shippingOrderId: Int!
    $jobId: Int!
  ) {
    MoveShippingOrder(input: {
      shippingOrderId: $shippingOrderId
      jobId: $jobId
    }) {
      success
      message
    }
  }
`

export const SYNC_INVOICE = gql`
  mutation SyncInvoice (
    $id: Int!
  ) {
    SyncInvoice(id: $id) {
      success
      message
    }
  }
`

export const UPDATE_INVOICE = gql`
  mutation UpdateInvoice (
    $id: Int!
    # $volume: Int
    # $number: Int
    $remark: String
    $createdDate: Date
    $paidDate: Date
    $dueDate: Date
    $files: [Upload]
    $paidfiles: [Upload]
    # $bank: String
    # $bankNumber: String
    # $chequeNumber: String
    # $chequeDate: Date
    # $grandTotal: Float
    # $withHoldingTax: PaymentInfoType
    # $amountWithHeld: Float
    # $bankFees: Float
    # $amountReceived: Float
    # $type: InvoicePaymentType
    $customerRefId: String
    $feeRate: Float
    $pricePerLitre: Float
    $isUpdateFeeRate: Boolean
    $revenueRecordDate: Date
  ) {
    UpdateInvoice (input: {
      id: $id
      # volume: $volume
      # number: $number
      remark: $remark
      createdDate: $createdDate
      paidDate: $paidDate
      dueDate: $dueDate
      files: $files
      paidfiles: $paidfiles
      customerRefId: $customerRefId
      # paymentInfo: {
      #   bank: $bank
      #   bankNumber: $bankNumber
      #   chequeNumber: $chequeNumber
      #   chequeDate: $chequeDate
      #   grandTotal: $grandTotal
      #   withHoldingTax: $withHoldingTax
      #   amountWithHeld: $amountWithHeld
      #   bankFees: $bankFees
      #   amountReceived: $amountReceived
      #   type: $type
      # }
      feeRate: $feeRate
      pricePerLitre: $pricePerLitre
      isUpdateFeeRate: $isUpdateFeeRate
      revenueRecordDate: $revenueRecordDate
    }) {
      success
      message
      updatedInvoice {
        id
        refId
        # volume
        # number
        files {
          id
          url
          filename
        }
      }
    }
  }
`

export const CREATE_INVOICE = gql`
  mutation CreateInvoice (
    # $volume: Int!
    # $number: Int!
    $createdDate: Date!
    $jobId: Int!
    $shippingId: [Int]!
    $dueDate: Date
    $customerRefId: String
    $remark: String
    $files: [Upload]
    $feeRate: Float
    $pricePerLitre: Float
    $isUpdateFeeRate: Boolean
    $revenueRecordDate: Date
  ) {
    CreateInvoice (input: {
      # volume: $volume
      # number: $number
      createdDate: $createdDate
      dueDate: $dueDate
      remark: $remark
      jobId: $jobId
      files: $files
      shippingId: $shippingId
      customerRefId: $customerRefId
      feeRate: $feeRate
      pricePerLitre: $pricePerLitre
      isUpdateFeeRate: $isUpdateFeeRate
      revenueRecordDate: $revenueRecordDate
    }) {
      success
      message
      createdInvoice {
        id
        refId
        # volume
        # number
        files {
          id
          url
          filename
        }
      }
    }
  }
`

export const IMPORT_FUEL_COST_SUMMARY = gql`
  mutation ImportFuelCostSummary (
    $data: [ImportFuelCostSummaryRowInput]
    $companyType: CompanyType!
  ) {
    ImportFuelCostSummary (input: {
      data: $data
      companyType: $companyType
    }) {
      success
      message
    }
  }
`

export const UPDATE_FUEL_ORDER = gql`
  mutation UpdateFuelOrder (
    $id: Int!
    $pricePerLitre: Float
    $kmPerLitre: Float
    $totalAmount: Float
    $fuelType: FuelType
    $remark: String
    $gasstationId: Int
    $expiredDate: Date
    $images: [Upload]
    $status: FuelOrderStatus
    $specialReason: String
    $specialReasonOther: String
  ){
    UpdateFuelOrder(input: {
      id: $id
      pricePerLitre: $pricePerLitre
      kmPerLitre: $kmPerLitre
      totalAmount: $totalAmount
      fuelType: $fuelType
      remark: $remark
      gasstationId: $gasstationId
      expiredDate: $expiredDate
      images: $images
      status: $status
      specialReason: $specialReason
      specialReasonOther: $specialReasonOther
    }) {
      success
      message
    }
  }
`

export const RECORD_FUEL_LOG = gql`
  mutation CreateFuelOrderLog (
    $fuelId: Int!
    $amount: Float!
    $isClose: Boolean
    $remark: String
    $files: [Upload]
    $pricePerLitre: Float
  ) {
    CreateFuelOrderLog(input: {
      fuelId: $fuelId
      amount: $amount
      isClose: $isClose
      remark: $remark
      files: $files
      pricePerLitre: $pricePerLitre
    }) {
      success
      message
    }
  }
`

export const TOGGLE_PAID_BY_FLEET_CARD = gql`
  mutation IsPaidByFleetCardFuelOrder (
    $id: Int!
    $isPaidByFleetCard: Boolean!
  ) {
    IsPaidByFleetCardFuelOrder(input:{
      id: $id
      isPaidByFleetCard: $isPaidByFleetCard
    }) {
      success
      message
    }
  }
`

export const CREATE_INVOICE_PAYMENT = gql`
  mutation CreateInvoicePayment (
    $invoiceId: Int!
    $bank: String
    $bankNumber: String
    $chequeNumber: String
    $chequeDate: Date
    $paidDate: Date
    $grandTotal: Float
    $withHoldingTax: PaymentInfoType
    $amountWithHeld: Float
    $customerBankFees: Float
    $pdrBankFees: Float
    $amountReceived: Float
    $type: InvoicePaymentType
    $isPartial: Boolean    
    $shippingsId: [Int]
    $paidfiles: [Upload]
    $lostWeightFee: Float
    $damagedGoodFee: Float
    $lostInsuranceFee: Float
    $discountFee: Float   
    $lateTicketFee: Float
    $excessPaymentFee: Float
    $accidentFee: Float
    $isCustomWitholdingTax: Boolean
  ) {
    CreateInvoicePayment (
      input: {
        invoiceId: $invoiceId
        bank: $bank
        bankNumber: $bankNumber
        chequeNumber: $chequeNumber
        chequeDate: $chequeDate
        paidDate: $paidDate
        grandTotal: $grandTotal
        withHoldingTax: $withHoldingTax
        amountWithHeld: $amountWithHeld
        customerBankFees: $customerBankFees
        pdrBankFees: $pdrBankFees
        amountReceived: $amountReceived
        type: $type
        isPartial: $isPartial        
        shippingsId: $shippingsId
        paidfiles: $paidfiles
        lostWeightFee: $lostWeightFee
        damagedGoodFee: $damagedGoodFee
        lostInsuranceFee: $lostInsuranceFee
        discountFee: $discountFee
        lateTicketFee: $lateTicketFee
        excessPaymentFee: $excessPaymentFee
        accidentFee: $accidentFee
        isCustomWitholdingTax: $isCustomWitholdingTax
      }
    ) {
      success
      message
    }
  }
`

export const CREATE_BILL_PAYMENT = gql`
  mutation CreateBillPayment (
    $billId: Int!
    $bank: String
    $bankNumber: String
    $chequeNumber: String
    $chequeDate: Date
    $paidDate: Date
    $grandTotal: Float
    $withHoldingTax: PaymentInfoType
    $amountWithHeld: Float
    $customerBankFees: Float
    $pdrBankFees: Float
    $amountReceived: Float
    $type: BillPaymentType
    $paidfiles: [Upload]
    $lostWeightFee: Float
    $damagedGoodFee: Float
    $lostInsuranceFee: Float
    $discountFee: Float   
    $lateTicketFee: Float
    $excessPaymentFee: Float
    $accidentFee: Float
    $isCustomWitholdingTax: Boolean
  ) {
    CreateBillPayment (
      input: {
        billId: $billId
        bank: $bank
        bankNumber: $bankNumber
        chequeNumber: $chequeNumber
        chequeDate: $chequeDate
        paidDate: $paidDate
        grandTotal: $grandTotal
        withHoldingTax: $withHoldingTax
        amountWithHeld: $amountWithHeld
        customerBankFees: $customerBankFees
        pdrBankFees: $pdrBankFees
        amountReceived: $amountReceived
        type: $type
        paidfiles: $paidfiles
        lostWeightFee: $lostWeightFee
        damagedGoodFee: $damagedGoodFee
        lostInsuranceFee: $lostInsuranceFee
        discountFee: $discountFee
        lateTicketFee: $lateTicketFee
        excessPaymentFee: $excessPaymentFee
        accidentFee: $accidentFee
        isCustomWitholdingTax: $isCustomWitholdingTax
      }
    ) {
      success
      message
    }
  }
`

export const SYNC_DRIVER_SALARY = gql`
  mutation SyncDriverSalary (
    $month: Date!
  ) {
    SyncDriverSalary(input:{
      month: $month
    }) {
      success
      message
    }
  }
`

export const SYNC_MECH_SALARY = gql`
  mutation SyncMechanicSalary (
    $month: Date!
  ) {
    SyncMechanicSalary(input:{
      month: $month
    }) {
      success
      message
    }
  }
`

export const SYNC_TRUCK_OWNER_REPORT = gql`
  mutation SyncTruckownerReport (
    $month: Date!
  ) {
    SyncTruckownerReport(input:{
      month: $month
    }) {
      notReadyList{
        id
        nameTh
      }
      syncSuccess
      success
      message
    }
  }
`

export const CONFIRM_SYNC_TRUCK_OWNER_REPORT = gql`
  mutation ConfirmSyncTruckownerReport (
    $month: Date!
  ) {
    ConfirmSyncTruckownerReport(input:{
      month: $month
    }) {
      success
      message
    }
  }
`

export const CREATE_SALARY_MECHANIC = gql`
  mutation CreateMechanicSalary (
    $mechanicId: Int!
    $salary: Float
    $overtime: Float
    $holidayPay: Float
    $holidayOvertime: Float
    $fieldWork: Float
    $depositRefund: Float
    $annualBonus: Float
    $otherIncome: Float
    $absence: Float
    $depositPay: Float
    $cooperativeShare: Float
    $cooperativeLoan: Float
    $withholdingTax: Float
    $socialSecurity: Float
    $waterBill: Float
    $electricBill: Float
    $ticketFines: Float
    $phoneBill: Float
    $damageCompensation: Float
    $gasCost: Float
    $airconditionBill: Float
    $shortWeight: Float
    $accountFee: Float
    $transferFee: Float
    $uniformCost: Float
    $otherCost: Float
    $netSalary: Float
    $periodStart: Date!
    $periodEnd: Date!
  ) {
    CreateMechanicSalary (input:{
      mechanicId: $mechanicId
      salary: $salary
      overtime: $overtime
      holidayPay: $holidayPay
      holidayOvertime: $holidayOvertime
      fieldWork: $fieldWork
      depositRefund: $depositRefund
      annualBonus: $annualBonus
      otherIncome: $otherIncome
      absence: $absence
      depositPay: $depositPay
      cooperativeShare: $cooperativeShare
      cooperativeLoan: $cooperativeLoan
      withholdingTax: $withholdingTax
      socialSecurity: $socialSecurity
      waterBill: $waterBill
      electricBill: $electricBill
      ticketFines: $ticketFines
      phoneBill: $phoneBill
      damageCompensation: $damageCompensation
      gasCost: $gasCost
      airconditionBill: $airconditionBill
      shortWeight: $shortWeight
      accountFee: $accountFee
      transferFee: $transferFee
      uniformCost: $uniformCost
      otherCost: $otherCost
      netSalary: $netSalary
      periodStart: $periodStart
      periodEnd: $periodEnd
    }) {
      success
      message
    }
  }
`

export const CREATE_SALARY_DRIVER = gql`
  mutation CreateDriverSalary (
    $driverId: Int!
    $salary: Float
    $overtime: Float
    $holidayPay: Float
    $holidayOvertime: Float
    $fieldWork: Float
    $depositRefund: Float
    $annualBonus: Float
    $otherIncome: Float
    $absence: Float
    $depositPay: Float
    $cooperativeShare: Float
    $cooperativeLoan: Float
    $withholdingTax: Float
    $socialSecurity: Float
    $waterBill: Float
    $electricBill: Float
    $ticketFines: Float
    $phoneBill: Float
    $damageCompensation: Float
    $gasCost: Float
    $airconditionBill: Float
    $shortWeight: Float
    $accountFee: Float
    $transferFee: Float
    $uniformCost: Float
    $otherCost: Float
    $netSalary: Float
    $periodStart: Date!
    $periodEnd: Date!
  ) {
    CreateDriverSalary (input:{
      driverId: $driverId
      salary: $salary
      overtime: $overtime
      holidayPay: $holidayPay
      holidayOvertime: $holidayOvertime
      fieldWork: $fieldWork
      depositRefund: $depositRefund
      annualBonus: $annualBonus
      otherIncome: $otherIncome
      absence: $absence
      depositPay: $depositPay
      cooperativeShare: $cooperativeShare
      cooperativeLoan: $cooperativeLoan
      withholdingTax: $withholdingTax
      socialSecurity: $socialSecurity
      waterBill: $waterBill
      electricBill: $electricBill
      ticketFines: $ticketFines
      phoneBill: $phoneBill
      damageCompensation: $damageCompensation
      gasCost: $gasCost
      airconditionBill: $airconditionBill
      shortWeight: $shortWeight
      accountFee: $accountFee
      transferFee: $transferFee
      uniformCost: $uniformCost
      otherCost: $otherCost
      netSalary: $netSalary
      periodStart: $periodStart
      periodEnd: $periodEnd
    }) {
      success
      message
    }
  }
`

export const UPDATE_INVOICE_PAYMENT = gql`
  mutation UpdateInvoicePayment (
    $id: Int!
    $bank: String
    $bankNumber: String
    $chequeNumber: String
    $chequeDate: Date
    $grandTotal: Float
    $withHoldingTax: PaymentInfoType
    $amountWithHeld: Float
    $customerBankFees: Float
    $pdrBankFees: Float
    $amountReceived: Float
    $type: InvoicePaymentType
    $shippingsId: [Int]
    $paidDate: Date
  ) {
    UpdateInvoicePayment (input:{
      id: $id
      bank: $bank
      bankNumber: $bankNumber
      chequeNumber: $chequeNumber
      chequeDate: $chequeDate
      grandTotal: $grandTotal
      withHoldingTax: $withHoldingTax
      amountWithHeld: $amountWithHeld
      customerBankFees: $customerBankFees
      pdrBankFees: $pdrBankFees
      amountReceived: $amountReceived
      type: $type
      shippingsId: $shippingsId
      paidDate: $paidDate
    }) {
      success
      message
    }
  }
`

export const UPDATE_BILL = gql`
  mutation UpdateBill (
    $id: Int!
    $createdDate: Date
    $dueDate: Date
    $paidDate: Date
    $status: BillType
    $remark: String
    $jobId: Int
    $images: [Upload]
    $paidimages: [Upload]
    $invoicesId: [Int]
  ) {
    UpdateBill (input: {
      id: $id
      createdDate: $createdDate
      dueDate: $dueDate
      paidDate: $paidDate
      status: $status
      remark: $remark
      jobId: $jobId
      images: $images
      paidimages: $paidimages
      invoicesId: $invoicesId
    }) {
      success
      message
    }
  }
`

export const ASSIGN_DRIVER = gql`
  mutation AssignDriver (
    $id: Int!
    $truckId: Int
    $driverId: Int
    $startTime: Date
    $remark: String
    $images: [Upload]
    $expensesHighway: Float
    $expensesEntranceStart: Float
    $expensesEntranceEnd: Float
    $expensesPickupStart: Float
    $expensesPickupEnd: Float
    $expensesOther: Float
    $feePickupHeavy: Float
    $feePierEntrance: Float
    $feePickupNormal: Float
    $feeOther: Float
    $truckFiles: [Upload]
  ) {
    AssignDriver (input: {
      id: $id
      truckId: $truckId
      driverId: $driverId
      startTime: $startTime
      remark: $remark
      images: $images
      expensesHighway: $expensesHighway
      expensesEntranceStart: $expensesEntranceStart
      expensesEntranceEnd: $expensesEntranceEnd
      expensesPickupStart: $expensesPickupStart
      expensesPickupEnd: $expensesPickupEnd
      expensesOther: $expensesOther
      feePickupHeavy: $feePickupHeavy
      feePierEntrance: $feePierEntrance
      feePickupNormal: $feePickupNormal
      feeOther: $feeOther
      truckFiles: $truckFiles
    }
  ) { 
      updatedShippingorder {
        id
        shippingCode
        shippingVolume
        shippingNumber
        customerId
        jobId
        startDestination
        endDestination
        truckId
        driverId
        assignDate
        startTime
        startWeight
        outTownFeeRate
        specialFeeRate
        endWeight
        expense
        recordDate
        tariff
        rateType
        expensesHighway
        expensesEntranceStart
        expensesEntranceEnd
        expensesPickupStart
        expensesPickupEnd
        expensesOther
        feePickupHeavy
        feePierEntrance
        feePickupNormal
        feeOther
        weightRecordId
        roundWeight
        bookingNo
        emptySackAmount
        startDestinationLocation {
          id
          name
          branch
          address
          createdAt
          updatedAt
        }
        endDestinationLocation {
          id
          name
          branch
          address
          createdAt
          updatedAt
        }
        weightDifferenceLimit
        unit
        totalWeight
        deliveryDate
        deliveryTime
        compensation
        variableShippingFee
        feeRate
        feeTotal
        fixedShippingFee
        remark
        status
        Driver {
          id
          employeeId
          fullname
          department
          platenumber
          status
          compensation
          totalFuelamountCompensation
          remainTickets
          remainFuel
        }
        Truck {
          id
          plateNumber
          fuelType
          status
          driver {
            id
            employeeId
            fullname
          }
          owner {
            id
            type
            nameTh
          }
          type {
            id
            nameTh
          }
          trailer {
            id
            trailerPlate
            status
          }
        }
        Job {
          id
          jobCode
          volumn
          number
          dealType
          startDestinationLocation {
            id
            name
            branch
            address
          }
          endDestinationLocation {
            id
            name
            branch
            address
          }
          unit
        }
        Customer {
          id
          companyId
          branch
          companyName
          groupId
          TypeOfCharge {
            id
            name
          }
        }
        FuelOrder {
          id
          fuelType
          status
          pricePerLitre
          kmPerLitre
          totalAmount
          filledAmount
          expiredDate
          fuelcompensation {
            totalDeduct
          }
          Gasstation {
            code
            id
            company
            name
          }
        }
        images {
          id
          url
          filename
        }
        createdAt
        updatedAt
      }
      success
      message
    }
  }
`

export const ADD_SHIPPING_ORDER_TO_INVOICE = gql`
  mutation AddShippingorderToInvoice(
    $invoiceId: Int!
    $shippingVolume: String!
    $shippingNumber: String!
  ) {
    AddShippingorderToInvoice( input:{
      invoiceId: $invoiceId
      shippingVolume: $shippingVolume
      shippingNumber: $shippingNumber
    }) {
      updatedInvoice{
        id
      }
      success
      message
    }
  }
`

export const REMOVE_SHIPPING_ORDER_FROM_INVOICE = gql`
  mutation RemoveShippingorderFromInvoice(
    $invoiceId: Int!
    $shippingId: Int!
  ) {
    RemoveShippingorderFromInvoice( input:{
      invoiceId: $invoiceId
      shippingId: $shippingId
    }) {
      updatedInvoice{
        id
      }
      success
      message
    }
  }
`

export const ASSIGN_FUEL = gql`
  mutation AssignFuelOrder (
    $id: Int!
    $pricePerLitre: Float
    # $kmPerLitre: Float
    $totalAmount: Float
    $gasstationId: Int
    $expiredDate: Date
    $remark: String
    $images: [Upload]
    $fuelType: FuelType
    $isPaidByFleetCard: Boolean
  ) {
    AssignFuelOrder (input: {
      id: $id
      pricePerLitre: $pricePerLitre
      # kmPerLitre: $kmPerLitre
      totalAmount: $totalAmount
      gasstationId: $gasstationId
      expiredDate: $expiredDate
      remark: $remark
      images: $images
      fuelType: $fuelType
      isPaidByFleetCard: $isPaidByFleetCard
    }
  ) { 
      updatedShippingorder {
        id
        shippingCode
        shippingVolume
        shippingNumber
        customerId
        jobId
        startDestination
        endDestination
        truckId
        driverId
        assignDate
        startTime
        startWeight
        endWeight
        expense
        tariff
        weightRecordId
        roundWeight
        startDestinationLocation {
          id
          name
          branch
          address
          createdAt
          updatedAt
        }
        endDestinationLocation {
          id
          name
          branch
          address
          createdAt
          updatedAt
        }
        weightDifferenceLimit
        unit
        totalWeight
        deliveryDate
        deliveryTime
        compensation
        variableShippingFee
        feeRate
        feeTotal
        fixedShippingFee
        remark
        status
        Driver {
          id
          employeeId
          fullname
          department
          platenumber
          status
          compensation
          totalFuelamountCompensation
          remainTickets
          remainFuel
        }
        Truck {
          id
          plateNumber
          fuelType
          status
          driver {
            id
            employeeId
            fullname
          }
          owner {
            id
            type
            nameTh
          }
          type {
            id
            nameTh
          }
        }
        Job {
          id
          jobCode
          volumn
          number
          dealType
        }
        Customer {
          id
          companyId
          branch
          companyName
          TypeOfCharge {
            id
            name
          }
        }
        FuelOrder {
          id
          fuelType
          status
          pricePerLitre
          kmPerLitre
          totalAmount
          filledAmount
          expiredDate
          fuelcompensation {
            totalDeduct
          }
          Gasstation {
            code
            id
            company
            name
          }
        }
        images {
          id
          url
          filename
        }
        createdAt
        updatedAt
      }
      success
      message
    }
  }
`

export const ASSIGN_DELIVERED = gql`
  mutation AssignDelivered (
    $id: Int!
    $assignDate: Date
    $startTime: Date
    $startWeight: Float
    $endWeight: Float
    $weightRecordId: String
    $weightDifference: Float
    $weightDifferenceLimit: Float
    $totalWeight: Float
    $deliveryDate: Date
    $deliveryTime: Time
    $compensation: Float
    $variableShippingFee: Float
    $feeRate: Float
    $feeTotal: Float
    $expense: Float
    $tariff: Float
    $fixedShippingFee: Float
    $roundWeight: Float
    $unit: ShippingUnitType
    $remark: String
    $images: [Upload]
    $expensesHighway: Float
    $expensesEntranceStart: Float
    $expensesEntranceEnd: Float
    $expensesPickupStart: Float
    $expensesPickupEnd: Float
    $expensesOther: Float
    $feePickupHeavy: Float
    $feePierEntrance: Float
    $feePickupNormal: Float
    $feeOther: Float
    $bookingNo: String
    $emptySackAmount: Int
    $outTownFeeRate: Float
    $specialFeeRate: Float
    $truckOwnerFeeRate: Float
    $pickedUpDate: Date
    $pickedUpTime: Time
    $truckWithCargoWeight: Float
  ) {
    AssignDelivered (input: {
      id: $id
      assignDate: $assignDate
      startTime: $startTime
      startWeight: $startWeight
      endWeight: $endWeight
      weightDifference: $weightDifference
      weightDifferenceLimit: $weightDifferenceLimit
      totalWeight: $totalWeight
      deliveryDate: $deliveryDate
      deliveryTime: $deliveryTime
      compensation: $compensation
      variableShippingFee: $variableShippingFee
      feeRate: $feeRate
      feeTotal: $feeTotal
      expense: $expense
      tariff: $tariff
      fixedShippingFee: $fixedShippingFee
      roundWeight: $roundWeight
      unit: $unit
      weightRecordId: $weightRecordId
      remark: $remark
      images: $images
      expensesHighway: $expensesHighway
      expensesEntranceStart: $expensesEntranceStart
      expensesEntranceEnd: $expensesEntranceEnd
      expensesPickupStart: $expensesPickupStart
      expensesPickupEnd: $expensesPickupEnd
      expensesOther: $expensesOther
      feePickupHeavy: $feePickupHeavy
      feePierEntrance: $feePierEntrance
      feePickupNormal: $feePickupNormal
      feeOther: $feeOther
      bookingNo: $bookingNo
      emptySackAmount: $emptySackAmount
      outTownFeeRate: $outTownFeeRate
      specialFeeRate: $specialFeeRate
      truckOwnerFeeRate: $truckOwnerFeeRate
      pickedUpDate: $pickedUpDate
      pickedUpTime: $pickedUpTime
      truckWithCargoWeight: $truckWithCargoWeight
    }
  ) { 
      updatedShippingorder {
        id
        shippingCode
        shippingVolume
        shippingNumber
        customerId
        jobId
        startDestination
        endDestination
        truckId
        driverId
        assignDate
        startTime
        startWeight
        endWeight
        expense
        tariff
        weightRecordId
        roundWeight
        startDestinationLocation {
          id
          name
          branch
          address
          createdAt
          updatedAt
        }
        endDestinationLocation {
          id
          name
          branch
          address
          createdAt
          updatedAt
        }
        weightDifferenceLimit
        unit
        totalWeight
        deliveryDate
        deliveryTime
        compensation
        variableShippingFee
        feeRate
        feeTotal
        fixedShippingFee
        remark
        status
        Driver {
          id
          employeeId
          fullname
          department
          platenumber
          status
          compensation
          totalFuelamountCompensation
          remainTickets
          remainFuel
        }
        Truck {
          id
          plateNumber
          fuelType
          status
          driver {
            id
            employeeId
            fullname
          }
          owner {
            id
            type
            nameTh
          }
          type {
            id
            nameTh
          }
        }
        Job {
          id
          jobCode
          volumn
          number
          dealType
        }
        Customer {
          id
          companyId
          branch
          companyName
          TypeOfCharge {
            id
            name
          }
        }
        FuelOrder {
          id
          fuelType
          status
          pricePerLitre
          kmPerLitre
          totalAmount
          filledAmount
          expiredDate
          fuelcompensation {
            totalDeduct
          }
          Gasstation {
            code
            id
            company
            name
          }
        }
        images {
          id
          url
          filename
        }
        createdAt
        updatedAt
      }
      success
      message
    }
  }
`

export const DRIVER_PICKED_UP = gql`
  mutation DriverPickedUp (
    $id: Int!
    $startWeight: Float
    $images: [Upload]!
    $truckWithCargoWeight: Float
    # $pickedUpDate: Date
    # $pickedUpTime: Time
  ) {
    DriverPickedUp (input: {
      id: $id
      startWeight: $startWeight
      images: $images
      truckWithCargoWeight: $truckWithCargoWeight
      # pickedUpDate: $pickedUpDate
      # pickedUpTime: $pickedUpTime
    }
  ) { 
      updatedShippingorder {
        id
      }
      success
      message
    }
  }
`

export const DRIVER_DELIVERED = gql`
  mutation DriverDelivered (
    $id: Int!
    $endWeight: Float
    $images: [Upload]!
    # $deliveryDate: Date
    # $deliveryTime: Time
  ) {
    DriverDelivered (input: {
      id: $id
      endWeight: $endWeight
      images: $images
      # deliveryDate: $deliveryDate
      # deliveryTime: $deliveryTime
    }
  ) { 
      updatedShippingorder {
        id
      }
      success
      message
    }
  }
`

export const CREATE_SENDER = gql`
  mutation CreateSenderLocation (
    $name: String
    $branch: String
    $address: String
    $taxId: String
  ) {
    CreateSenderLocation(input: {
      name: $name
      branch: $branch
      address: $address
      taxId: $taxId
    }) {
      success
      message
    }
  }
`

export const CREATE_RECEIVER = gql`
  mutation CreateReceiverLocation (
    $name: String
    $branch: String
    $address: String
    $taxId: String
  ) {
    CreateReceiverLocation(input: {
      name: $name
      branch: $branch
      address: $address
      taxId: $taxId
    }) {
      success
      message
    }
  }
`

export const UPDATE_SENDER = gql`
  mutation UpdateSenderLocation (
    $id: Int!
    $name: String
    $branch: String
    $address: String
    $taxId: String
  ) {
    UpdateSenderLocation(input: {
      id: $id
      name: $name
      branch: $branch
      address: $address
      taxId: $taxId
    }) {
      success
      message
    }
  }
`

export const UPDATE_RECEIVER = gql`
  mutation UpdateReceiverLocation (
    $id: Int!
    $name: String
    $branch: String
    $address: String
    $taxId: String
  ) {
    UpdateReceiverLocation(input: {
      id: $id
      name: $name
      branch: $branch
      address: $address
      taxId: $taxId
    }) {
      success
      message
    }
  }
`

export const CREATE_MECHANIC = gql`
  mutation CreateMechanic (
    $firstname: String
    $lastname: String
    $department: String
    $email: String
    $startDate: Date
    $nationalId: String
    $phoneNumber: String
    $quitDate: Date
    $bankAccountNumber: String
    $bankName: String
    $salary: Float
    $birthDay: Date
    $insuranceNumber: String
    $skills: [Int]
    $companyType: MechanicCompanyType
  ) {
    CreateMechanic(input: {
      firstname : $firstname
      lastname: $lastname
      department: $department
      email: $email
      startDate: $startDate
      nationalId: $nationalId
      phoneNumber: $phoneNumber
      quitDate: $quitDate
      bankAccountNumber: $bankAccountNumber
      bankName: $bankName
      salary: $salary
      birthDay: $birthDay
      insuranceNumber: $insuranceNumber
      skills: $skills
      companyType: $companyType
    }) {
      success
      message
    }
  }
`

export const UPDATE_MECHANIC = gql`
  mutation UpdateMechanic (
    $id: Int!
    $firstname: String
    $lastname: String
    $department: String
    $email: String
    $startDate: Date
    $nationalId: String
    $phoneNumber: String
    $quitDate: Date
    $bankAccountNumber: String
    $bankName: String
    $salary: Float
    $birthDay: Date
    $insuranceNumber: String
    $skills: [Int]
  ) {
    UpdateMechanic(input: {
      id: $id
      firstname : $firstname
      lastname: $lastname
      department: $department
      email: $email
      startDate: $startDate
      nationalId: $nationalId
      phoneNumber: $phoneNumber
      quitDate: $quitDate
      bankAccountNumber: $bankAccountNumber
      bankName: $bankName
      salary: $salary
      birthDay: $birthDay
      insuranceNumber: $insuranceNumber
      skills: $skills
    }) {
      success
      message
    }
  }
`

export const CREATE_REPAIR_JOB = gql`
  mutation CreateRepairJob (
    $truckId: Int!
    $description: String
    $currentFuel: Int
    $currentMile: Int
    $remark: String
    $deadlineDate: Date
    $isOutsource: Boolean
    $outsourceType: RepairOutsourceType
    $garageId: Int
    $outsourceRemark: String
    $files: [Upload]
    $driverId: Int
    $phoneNumber: String
    $isPending: Boolean
    $warehouseId: Int
    $trailerId: Int
    $isRepairTruck: Boolean
    $repairTruckType: RepairJobType
    $repairTruckTypeOther: String
    $isRepairTrailer: Boolean
    $repairTrailerType: RepairJobType
    $repairTrailerTypeOther: String
    $price: Float
    $expense: Float
    $expenseTire: Float
  ) {
    CreateRepairJob(input: {
      truckId: $truckId
      description: $description
      currentFuel: $currentFuel
      currentMile: $currentMile
      remark: $remark
      deadlineDate: $deadlineDate
      files: $files
      isOutsource: $isOutsource
      outsourceType: $outsourceType
      garageId: $garageId
      outsourceRemark: $outsourceRemark
      driverId: $driverId
      phoneNumber: $phoneNumber
      isPending: $isPending
      warehouseId: $warehouseId
      trailerId: $trailerId
      isRepairTruck: $isRepairTruck
      repairTruckType: $repairTruckType
      repairTruckTypeOther: $repairTruckTypeOther
      isRepairTrailer: $isRepairTrailer
      repairTrailerType: $repairTrailerType
      repairTrailerTypeOther: $repairTrailerTypeOther
      price: $price
      expense: $expense
      expenseTire: $expenseTire
    }) {
      success
      message
    }
  }
`

export const UPDATE_REPAIR_JOB = gql`
  mutation UpdateRepairJob (
    $id: Int!
    $description: String
    $currentFuel: Int
    $currentMile: Int
    $remark: String
    $deadlineDate: Date
    $files: [Upload]
    $isOutsource: Boolean
    $outsourceType: RepairOutsourceType
    $garageId: Int
    $outsourceRemark: String
    $driverId: Int
    $phoneNumber: String
    $isPending: Boolean
    $warehouseId: Int
    $price: Float
    $expense: Float
    $expenseTire: Float
    $tireCarrierDriverId: Int
    $repairTruckType: RepairJobType
    $repairTruckTypeOther: String
    $repairTrailerType: RepairJobType
    $repairTrailerTypeOther: String
  ) {
    UpdateRepairJob(input: {
      id: $id
      description: $description
      currentFuel: $currentFuel
      currentMile: $currentMile
      remark: $remark
      deadlineDate: $deadlineDate
      files: $files
      isOutsource: $isOutsource
      outsourceType: $outsourceType
      garageId: $garageId
      outsourceRemark: $outsourceRemark
      driverId: $driverId
      phoneNumber: $phoneNumber
      isPending: $isPending
      warehouseId: $warehouseId
      price: $price
      expense: $expense
      expenseTire: $expenseTire
      tireCarrierDriverId: $tireCarrierDriverId
      repairTruckType: $repairTruckType
      repairTruckTypeOther: $repairTruckTypeOther
      repairTrailerType: $repairTrailerType
      repairTrailerTypeOther: $repairTrailerTypeOther
    }) {
      success
      message
    }
  }
`

export const CREATE_REPAIR_SERVICE = gql`
  mutation CreateRepairService (
    $repairId: Int!
    $mechanicId: Int
    $remark: String
    $beforeRepairImages: [Upload]
    $isRepairTruck: Boolean
    $isRepairTrailer: Boolean
    $serviceType: RepairServiceType
    $skillId: [Int]
  ) {
    CreateRepairService(input: {
      repairId: $repairId
      mechanicId: $mechanicId
      remark: $remark
      beforeRepairImages: $beforeRepairImages
      isRepairTruck: $isRepairTruck
      isRepairTrailer: $isRepairTrailer
      serviceType: $serviceType
      skillId: $skillId
    }) {
      success
      message
    }
  }
`

export const UPDATE_REPAIR_SERVICE = gql`
  mutation UpdateRepairService (
    $id: Int!
    $mechanicId: Int
    $remark: String
    $beforeRepairImages: [Upload]
    $skillId: [Int]
  ) {
    UpdateRepairService(input: {
      id: $id
      mechanicId: $mechanicId
      remark: $remark
      beforeRepairImages: $beforeRepairImages
      skillId: $skillId
    }) {
      success
      message
    }
  }
`

export const ASSIGN_MECHANIC = gql`
  mutation AssignMechanicToRepairService (
    $id: Int!
    $mechanicId: Int!
  ) {
    AssignMechanicToRepairService(input: {
      id: $id
      mechanicId: $mechanicId
    }) {
      success
      message
    }
  }
`

export const START_SERVICE = gql`
  mutation AssignMechanicStartRepair (
    $id: Int!
    $items: [BorrowItemData]
    $beforeRepairImages: [Upload]
  ) {
    AssignMechanicStartRepair(input: {
      id: $id
      items: $items
      beforeRepairImages: $beforeRepairImages
    }) {
      success
      message
    }
  }
`

export const START_SERVICE_TIRE = gql`
  mutation AssignMechanicStartRepairTire (
    $id: Int!
    $items: [TireInstallData]
    $beforeRepairImages: [Upload]
  ) {
    AssignMechanicStartRepairTire(input:{
      id: $id
      items: $items
      beforeRepairImages: $beforeRepairImages
    }) {
      success
      message
    }
  }
`

export const CLOSE_SERVICE = gql`
  mutation AssignFinishRepairService (
    $id: Int!
    $items: [ReturnItemData]
    $afterRepairImages: [Upload]
  ) {
    AssignFinishRepairService(input: {
      id: $id
      items: $items
      afterRepairImages: $afterRepairImages
    }) {
      success
      message
      canCloseJob
      UpdatedRepairJob {
        id
        Truck {
          id
          plateNumber
        }
        remark
      }
    }
  }
`

export const CLOSE_SERVICE_TIRE = gql`
  mutation AssignFinishRepairServiceTire (
    $id: Int!
    $items: [TireUnInstallData]
    $afterRepairImages: [Upload]
  ) {
    AssignFinishRepairServiceTire(input: {
      id: $id
      items: $items
      afterRepairImages: $afterRepairImages
    }) {
      success
      message
      canCloseJob
      UpdatedRepairJob {
        id
        Truck {
          id
          plateNumber
        }
        remark
      }
    }
  }
`

export const CLOSE_JOB = gql`
  mutation CloseRepairJob (
    $id: Int!
    $description: String
    $remark: String
    $closeDate: Date!
    $isWatching: Boolean
    $files: [Upload]
  ) {
    CloseRepairJob(input: {
      id: $id
      description: $description
      remark: $remark
      closeDate: $closeDate
      isWatching: $isWatching
      files: $files
    }) {
      success
      message
    }
  }
`

export const CANCEL_SERVICE = gql`
  mutation CancelRepairService (
    $id: Int!
    $cancelReason: String
  ) {
    CancelRepairService(input: {
      id: $id
      cancelReason: $cancelReason
    }) {
      success
      message
    }
  }
`

export const CANCEL_JOB = gql`
  mutation CancelRepairJob (
    $id: Int!
    $description: String
    $remark: String
  ) {
    CancelRepairJob(input: {
      id: $id
      description: $description
      remark: $remark
    }) {
      success
      message
    }
  }
`

export const CREATE_FUEL_ORDER_FOR_REPAIR_JOB = gql`
  mutation CreateRepairJobFuel (
    $repairId: Int!
    $pricePerLitre: Float
    $kmPerLitre: Float
    $totalAmount: Float
    $price: Float
    $fuelType: FuelType
    $remark: String
    $files: [Upload]
    $expiredDate: Date
    $start: String
    $end: String
    $mechanicId: Int
    $driverId: Int
    $userId: Int
    $gasstationId: Int
  ) {
    CreateRepairJobFuel (input:{
      repairId: $repairId
      pricePerLitre: $pricePerLitre
      kmPerLitre: $kmPerLitre
      totalAmount: $totalAmount
      price: $price
      fuelType: $fuelType
      remark: $remark
      files: $files
      expiredDate: $expiredDate
      start: $start
      end: $end
      mechanicId: $mechanicId
      driverId: $driverId
      userId: $userId
      gasstationId: $gasstationId
    }) {
      createdRepairJobFuel{
        id
      }
      success
      message
    }
  }
`

export const EDIT_FUEL_ORDER_FOR_REPAIR_JOB = gql`
  mutation UpdateRepairJobFuel (
    $id: Int!
    $pricePerLitre: Float
    $totalAmount: Float
  ) {
    UpdateRepairJobFuel (input:{
      id: $id
      pricePerLitre: $pricePerLitre
      totalAmount: $totalAmount
    }) {
      success
      message
    }
  }
`

export const CREATE_GARAGE = gql`
  mutation CreateGarage (
    $name: String
    $phoneNumber: String
    $address: String
    $taxId: String
  ){
    CreateGarage (input:{
      name: $name
      phoneNumber: $phoneNumber
      address: $address
      taxId: $taxId
    }) {
      success
      message
    }
  }
`

export const CREATE_TIRE_PATCH_SHOP = gql`
  mutation CreateTirePatchStore (
    $name: String!
    $phoneNumber: String!
    $address: String
    $taxId: String
  ){
    CreateTirePatchStore (input:{
      name: $name
      phoneNumber: $phoneNumber
      address: $address
      taxId: $taxId
    }) {
      success
      message
    }
  }
`

export const CREATE_TRAILER = gql`
  mutation CreateTrailer (
    $trailerPlate: String
    $chassisNumber: String
    $truckTypeId: Int
  ) {
    CreateTrailer(input: {
      trailerPlate: $trailerPlate
      chassisNumber: $chassisNumber
      truckTypeId: $truckTypeId
    }) {
      success
      message
    }
  }
`

export const UPDATE_GARAGE = gql`
  mutation UpdateGarage (
    $id: Int!
    $name: String
    $phoneNumber: String
    $address: String
    $taxId: String
  ){
    UpdateGarage (input:{
      id: $id
      name: $name
      phoneNumber: $phoneNumber
      address: $address
      taxId: $taxId
    }) {
      success
      message
    }
  }
`

export const UPDATE_TIRE_PATCH_SHOP = gql`
  mutation UpdateTirePatchStore (
    $id: Int!
    $name: String
    $phoneNumber: String
    $address: String
    $taxId: String
  ){
    UpdateTirePatchStore (input:{
      id: $id
      name: $name
      phoneNumber: $phoneNumber
      address: $address
      taxId: $taxId
    }) {
      success
      message
    }
  }
`

export const UPDATE_TRAILER = gql`
  mutation UpdateTrailer(
    $id: Int!
    $trailerPlate: String
    $chassisNumber: String
    $truckTypeId: Int
  ) {
    UpdateTrailer(input: {
      id: $id
      trailerPlate: $trailerPlate
      chassisNumber: $chassisNumber
      truckTypeId: $truckTypeId
    }) {
      success
      message
    }
  }
`

export const DELETE_GARAGE = gql`
  mutation DeleteGarage (
    $id: Int!
  ){
    DeleteGarage (input:{
      id: $id
    }) {
      success
      message
    }
  }
`

export const DELETE_INVOICE = gql`
  mutation DeleteInvoice (
    $id: Int!
  ){
    DeleteInvoice (input:{
      id: $id
    }) {
      success
      message
    }
  }
`

export const IMPORT_FIXED_COST = gql`
  mutation ImportFixedCostExcel (
    $company: CompanyType
    $data: [ImportFixedCostExcelRowInput]
    $isConfirm: Boolean
  ) {
    ImportFixedCostExcel (input: {
      excelData: {
        company: $company
        data: $data
      }
      isConfirm: $isConfirm
    }) {
      success
      message
      data {
        costType
        totalAmount
        list {
          costName
          date
          amount
          companyType
        }
      }
    }
  }
`
